import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormat'
})
export class CurrencyFormatPipe implements PipeTransform {
  transform(value: number | undefined, currency: string): string {
    if (typeof value !== 'number') {
      return '';
    }

    const formattedNumber = new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true,
    }).format(value);

    return currency === 'ARS'
      ? `$ ${formattedNumber}`
      : `${currency} ${formattedNumber}`;
  }
}